module.exports = __webpack_public_path__ + "img/Logo_EmPower-2020-white.9b5f0284.png";